import { CartActionTypes, CartActions } from './cart.actions';
import { Cart } from '../../dto';

export const CART_STORE_NAME = 'cart';

export const initialState: Cart[] = [];

export function cartReducer(state = initialState, action: CartActions) {
  switch (action.type) {
    case CartActionTypes.SET_CART:
      // return [...state, action.payload];
      return action.payload ? action.payload : [];
    case CartActionTypes.ADD_CART:
      for (const item of state) {
        if (item.id === action.payload.id) {
          return state;
        }
      }
      return [...state, action.payload];
    case CartActionTypes.REMOVE_CART:
      return state.filter((item) => !action.payload.includes(item.id));
    default:
      return state;
  }
}
